import { Button, Divider, Menu, MenuItem, Typography } from "@mui/material";
import React, { useCallback } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { useResponsive } from "../../../../hooks/useResponsive";
import CustomMenu from "../../../../components/Menu";
import { CustomButton } from "../../../../components/Button/Button";
import { FilterOptionsList } from "../../../../components/FilterOptionsList";
import { boardStatusFilter } from "../../../../utils/constants/index.js";
import { DownArrowIcon } from "../../../../components/DownArrowIcon.js";

function FilterArchive() {
  const [filterMenu, setFilterMenu] = React.useState(null);
  const [filterBoard, updateParams, removeSearchParam] =
    useCustomSearchParams("boards-type");

  const isMobile = useResponsive("down", "md");

  const handleClick = useCallback((event) => {
    setFilterMenu(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setFilterMenu(null);
  }, []);

  const openFilterMenu = Boolean(filterMenu);

  return (
    <React.Fragment>
      {isMobile ? (
        <>
          <FilterOptionsList
            options={boardStatusFilter}
            filterType={filterBoard}
            paramsKey={"boards-type"}
          />
        </>
      ) : (
        <CustomButton
          variant="outlined"
          // color="primary"
          className="filter-btn white-button "
          onClick={handleClick}
          endIcon={<DownArrowIcon/>}
        >
          <p className="mr-4 capitalize">{filterBoard || "All"}</p>
        </CustomButton>
      )}
      <CustomMenu
        id="account-menu"
        anchorEl={filterMenu}
        className="assign-board-owner-list"
        open={openFilterMenu}
        onClose={handleClose}
        onClick={handleClose}
      >
        <FilterOptionsList
          options={boardStatusFilter}
          filterType={filterBoard}
          paramsKey={"boards-type"}
        />
      </CustomMenu>
    </React.Fragment>
  );
}

export default React.memo(FilterArchive);
